// Stage enum for environment-based routing
export enum Env {
  dev = 'DEV',
  staging = 'STAGING',
  prod = 'PROD',
}

/**
 * Map of redirect path regexes by Stage
 */
export const NEXT_ROUTING_PATH_REGEXS: Map<Env, RegExp[]> = new Map([
  [Env.dev, [/^\/about-us(\/)?$/, /^\/search(\/)?$/, /^\/$/]],
  [Env.staging, [/^\/about-us(\/)?$/, /^\/search(\/)?$/]],
  [Env.prod, [/^\/about-us(\/)?$/, /^\/search(\/)?$/]],
]);
